import React from 'react'
import { strings } from '../../../localization/strings'
import ConfigPanel from './configPanel'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import { MoneyNumberFormat } from '../../../utils/formaters'
import Alert from '@material-ui/lab/Alert'

const Component = ({ config, handleEdit }) => {
    const checkErrors = (automaticInsure, defaultInsuredValue) => {
        let { maximumInsurableValue } = config
        if (!automaticInsure) {
            if (defaultInsuredValue > maximumInsurableValue)
                return strings.orderInsureIsMaximum
            if (defaultInsuredValue.length === 0)
                return strings.orderInsureInvalidInput
        } else {
            return null
        }
    }

    let error = checkErrors(config.automaticInsure, config.defaultInsuredValue)

    return (
        <>
            <ConfigPanel
                title={strings.insuranceConfigTitle}
                items={[
                    {
                        label: strings.insuranceConfigItemsTotal,
                        control: (
                            <Switch
                                color="primary"
                                checked={config.automaticInsure}
                                onChange={(x) =>
                                    handleEdit({
                                        wasEdited: !checkErrors(
                                            x.target.checked,
                                            config.defaultInsuredValue
                                        ),
                                        config: {
                                            ...config,
                                            automaticInsure: x.target.checked,
                                        },
                                    })
                                }
                                name="checkedA"
                                inputProps={{
                                    'aria-label': 'secondary checkbox',
                                }}
                            />
                        ),
                    },
                    {
                        label: strings.insuranceConfigDefaultValue,
                        control: (
                            <TextField
                                value={config.defaultInsuredValue}
                                onChange={(x) =>
                                    handleEdit({
                                        wasEdited: !checkErrors(
                                            config.automaticInsure,
                                            x.target.value
                                        ),
                                        config: {
                                            ...config,
                                            defaultInsuredValue: x.target.value,
                                        },
                                    })
                                }
                                error={!!error}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    maxLength: 20,
                                    inputComponent: MoneyNumberFormat,
                                }}
                                disabled={config.automaticInsure}
                            />
                        ),
                    },
                ]}
            />
            {!error ? null : <Alert severity="error">{error}</Alert>}
            <div
                style={{
                    fontSize: '75%',
                    backgroundColor: 'lightgoldenrodyellow',
                    padding: 10,
                    marginTop: 18,
                    marginBottom: 18,
                    whiteSpace: 'pre-line',
                }}
            >
                {strings.orderInsureMaxValue.replace(
                    '{{maximum}}',
                    config.maximumInsurableValue.toFixed(2)
                )}
            </div>
        </>
    )
}

export default Component
